import React, { useState, useEffect } from "react";
import {
  VStack,
  Grid,
  Box,
  Flex,
  useToast,
  IconButton,
  Divider,
  Button,
} from "@chakra-ui/react";

import { AgGridColumn, AgGridReact } from "ag-grid-react";
// import RingLoader from "react-spinners/RingLoader";

//Icons
import { AiOutlineDelete } from "react-icons/ai";
import { FaExternalLinkAlt } from "react-icons/fa";
//Custom components
import Sidebar from "../sections/Sidebar/Sidebar";
import FileUpload from "../common/FileUpload";
import BreadCrumbs from '../common/BreadCrumbs'
import Loader from '../common/Loader'; 
import Header from  '../sections/Header';
import DateRangeSelector from './DateRangeSelector';
import RuleSnapshotModal from "../preference/RuleSnapshotModal";

//services
import MerchantService from "../../services/merchant.service";
import { FormatDateAndTime,FormatDate } from '../../utils/utilities';
import { filterParams } from '../../utils/ag-grid';
import { getCountryNameWithCountryCode,countryDefault } from '../../config/static/country';

//Style
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "./style.css";


const TransactionList = (props) => {
  const toast = useToast();
  const [isLoading, setisLoading] = useState(false);
  const [ gridApi , setGridApi] = useState(null);
  const [fileData, setFileData] = useState([]);
  const [snapshotHash, setSnapshotHash] = useState(null);
  // const [validationErrors, setValidationErrors] = useState({
  //   startDate: null,
  //   endDate: null,
  // });
  const [actionList , setActionList] = useState([{ label: "Select the action", value: ""}])
  let user = JSON.parse(localStorage.getItem("user"));

  const defaultColDef = {
    sortable: true,
    resizable: true,
    filter: true,
    editable: false
  };

  const onGridReady = (params) => {
    setGridApi(params.api);
  };
  const onFirstDataRendered = (params) => {
    params.api.sizeColumnsToFit();
  };  
  // const rowDataChanged = (params) => {
  //   console.log('sdf')
  //   params.api.sizeColumnsToFit();
  // };  
  const getFiles = (startDate=new Date(),endDate=new Date()) =>{
    setisLoading(true)
    if (gridApi) gridApi.showLoadingOverlay();
    MerchantService.getFiles({startDate,endDate})
    .then(data=>{
      setisLoading(false)
      if (data.error) {
        toast({
          title: data.error,
          position: "top",
          status: "error",
          isClosable: true,
        });
        setisLoading(false);
        if (gridApi) gridApi.hideOverlay();
        return;
      }
      setFileData(data.data);
      if (gridApi) (data.data && data.data.length) ? gridApi.hideOverlay() : gridApi.showNoRowsOverlay();
    })
    if(gridApi)
      gridApi.sizeColumnsToFit();
  }

  useEffect(() => {
    if (user.user && user.user.role && user.user.permissions.includes('deleteExcel'))
      setActionList(prev => [...prev,{ label: "DELETE", value: "DELETE" }]);
    getFiles();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fileUploadSubmit = (postData)=>{
    setisLoading(true);
    MerchantService.uploadFile(postData).then(data=>{
      setisLoading(false);
      if (data.error) {
        toast({
          title: data.error,
          position: "top",
          status: "error",
          isClosable: true,
        });
        return;
      }
      if(data.warning){
        toast({
          title: data.warning,
          position: "top",
          status: "warning",
          duration: 10000,
          isClosable: true,
        });
        setisLoading(false);
        return;
      }
      toast({
        title: `The data is uploaded suceessfully. And the automated case creation is being processed.`,
        position: "top",
        status: "success",
        isClosable: true,
      });
      setFileData([...fileData,data.data[0]])
      //getFiles();
    });
    setisLoading(false)
  } 

  const deleteFile = (rowData,gridApi) =>{
    //gridApi.applyTransaction({ remove: [data] });
    //return;
    setisLoading(true);
    let fileCountry = countryDefault;
    if(rowData.fileCountry){
      fileCountry = rowData.fileCountry;
    }
    MerchantService.deleteFile({fileDate:rowData.fileDate,fileCountry}).then(data=>{
        setisLoading(false);
        if (data.error) {
            toast({
                title: data.error,
                position: "top",
                status: "error",
          isClosable: true,
        });
        return;
      }
      if(data.warning){
          toast({
          title: data.warning,
          position: "top",
          status: "warning",
          duration: 10000,
          isClosable: true,
        });
        setisLoading(false);
        return;
      }
      toast({
          title: `File removed.`,
        position: "top",
        status: "success",
        isClosable: true,
      });
      gridApi.applyTransaction({ remove: [rowData] });
    });
    setisLoading(false);
  }
  const cellUpdateForDateAndTime = (props) => {
    // const field = props["colDef"]["field"];
    if (typeof props["value"] !== "undefined") {
      let value = FormatDateAndTime(props["value"]);
      return value;
    }
    return;
  };
  const cellUpdateForDate = (props) => {
    // const field = props["colDef"]["field"];
    if (typeof props["value"] !== "undefined") {
      let value = FormatDate(props["value"]);
      return value;
    }
    return;
  };
  const cellUpdateForCountry = (props) => {
    return getCountryNameWithCountryCode(props["value"]);
  };

  const dateComparator = (value1, value2) => {
    if (new Date(value1) === new Date(value2)) return 0;
    return new Date(value1) > new Date(value2) ? 1 : -1;
  };
  return (
    <Box>
      <Flex>
        <Sidebar />
        <Box w="100%">
          <Loader isLoading={isLoading} />
          <Header>
            <DateRangeSelector 
            startDate = {new Date()}
            endDate = {new Date()}
            handleSubmit = {getFiles}
            />
            <Divider pr={2} h="60px" orientation="vertical" />
            <Box >
              <FileUpload onSubmit={fileUploadSubmit}/>
            </Box>
          </Header>
          <Box  pl="2" pb="2" > <BreadCrumbs /> </Box>
          <Grid minH="87vh" pl={3} pr={2}>
            <VStack spacing={1}>
              <Box
                style={{ height: "100%", width: "100%" }}
                className="ag-theme-alpine"
              >
                <AgGridReact
                  rowData={fileData}
                  // rowSelection="multiple"
                  frameworkComponents={{
                    externalLink: (props) => {
                      return (
                        <Box display='inline-block'>  
                          <a style={{cursor:"pointer"}}
                            target="_blank"
                            rel="noreferrer"
                            href={`transaction/view?date=${props.data.fileDate}&country=${props.data.fileCountry}`}
                          >
                          <FaExternalLinkAlt/>
                          </a>
                        </Box>
                      );
                    },
                    deleteButton: (props)=>{
                      return(
                        <Box display='inline-block' >
                        <IconButton
                         size="md"
                         onClick={()=> deleteFile(props.data,props.api) }
                         backgroundColor={'white'}
                         icon={<AiOutlineDelete />}
                        />
                        </Box>
                      )
                    },
                    rulesUsed: (props)=>{
                      const hash = props.data && props.data.ruleSnapshotHash;
                      if(!hash) return <Box as="span" color="gray.400">—</Box>;
                      return (
                        <Button size="xs" variant="link" colorScheme="teal" onClick={()=> setSnapshotHash(hash)}>
                          View
                        </Button>
                      );
                    }
                  }}
                  defaultColDef={defaultColDef}
                  pagination={true}
                  paginationPageSize={17}
                  onGridReady={onGridReady}
                  onFirstDataRendered={onFirstDataRendered}
                  onRowDataChanged={onFirstDataRendered}
                  // rowDataChanged={rowDataChanged}
                >
                 {actionList.length>1 && (
                     <AgGridColumn
                      width={70}
                      sortable={false}
                      filter={false}
                      cellRenderer="deleteButton"
                      //headerCheckboxSelection={true}
                      //checkboxSelection={true}
                      //headerCheckboxSelectionFilteredOnly={true}
                      lockPosition={true}
                      pinned='left'
                    />
                  )}
                  <AgGridColumn
                    headerName=""
                    cellRenderer="externalLink"
                    lockPosition={true}
                    sortable={false}
                    filter={false}
                    width={70}
                    pinned='left'
                  ></AgGridColumn>
                  {/* <AgGridColumn
                    headerName="File Name"
                    field="fileName"
                    lockPosition={true}
                    filter="agTextColumnFilter"
                    filterParams={filterParams}
                  ></AgGridColumn> */}
                  <AgGridColumn
                    headerName="File Date"
                    field="fileDate"
                    cellRenderer={cellUpdateForDate}
                    lockPosition={true}
                    filter="agDateColumnFilter"
                    filterParams={filterParams}
                    comparator={dateComparator}
                  ></AgGridColumn>
                  <AgGridColumn
                    headerName="Country"
                    field="fileCountry"
                    lockPosition={true}
                    filter="agTextColumnFilter"
                    cellRenderer={cellUpdateForCountry}
                  ></AgGridColumn>
                  <AgGridColumn
                    headerName="Created By"
                    field="createdBy"
                    lockPosition={true}
                    filter= 'agTextColumnFilter'
                  ></AgGridColumn>
                  <AgGridColumn
                    headerName="Created Date"
                    field="createdDate"
                    lockPosition={true}
                    cellRenderer={cellUpdateForDate}
                    filter="agDateColumnFilter"
                    filterParams={filterParams}
                    comparator={dateComparator}
                  ></AgGridColumn>
                  <AgGridColumn
                    headerName="Updated By"
                    field="updatedBy"
                    lockPosition={true}
                    filter= 'agTextColumnFilter'
                  ></AgGridColumn>
                  <AgGridColumn
                    headerName="Updated Date"
                    field="updatedDate"
                    lockPosition={true}
                    cellRenderer={cellUpdateForDateAndTime}
                    filter="agDateColumnFilter"
                    filterParams={filterParams}
                    comparator={dateComparator}
                  ></AgGridColumn>
                  <AgGridColumn
                    headerName="Rules used"
                    field="ruleSnapshotHash"
                    lockPosition={true}
                    sortable={false}
                    filter={false}
                    width={110}
                    cellRenderer="rulesUsed"
                  ></AgGridColumn>

                </AgGridReact>
              </Box>
              {/* </VStack>
            </Grid>
          </Box>
        </Box>
      </Flex>
    </Box> */}
            </VStack>
          </Grid>
        </Box>
      </Flex>
      <RuleSnapshotModal
        isOpen={!!snapshotHash}
        hash={snapshotHash}
        onClose={() => setSnapshotHash(null)}
        title="Rules used for this upload"
      />
    </Box>
  );
};

export default TransactionList;

